"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _material = require("@heron-web/material");
var _hopsSdkJs = require("@hps/hops-sdk-js");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * Radio control for ticket journey type selection
 * 
 * @package HOPS
 * @subpackage Tickets
 * @author Heron Web Ltd
 * @copyright Heritage Operations Processing Limited
 */
class TicketsJourneyTypeRadio extends _react.default.PureComponent {
  /**
   * Render.
   * 
   * @return {ReactNode}
   */
  render() {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Radio, {
      color: this.props.color,
      disabled: this.props.disabled,
      name: this.props.name,
      onChange: this.props.onChange,
      options: this.options,
      row: !this.props.row,
      value: this.props.value
    });
  }

  /**
   * Get our options.
   * 
   * @return {Array<Object>}
   */
  get options() {
    return Object.keys(_hopsSdkJs.TicketJourneyTypes.values).map(key => {
      const value = _hopsSdkJs.TicketJourneyTypes.values[key];
      return {
        label: _hopsSdkJs.TicketJourneyTypes.getLabel(value),
        value: _hopsSdkJs.TicketJourneyTypes.values[key],
        hidden: this.props.hiddenOptions?.includes(value)
      };
    });
  }
  static propTypes = {
    color: _propTypes.default.oneOf(["primary", "secondary"]),
    disabled: _propTypes.default.bool,
    onChange: _propTypes.default.func,
    row: _propTypes.default.bool,
    value: _propTypes.default.number
  };
  static defaultProps = {
    color: "primary",
    disabled: false,
    row: false
  };
}
var _default = TicketsJourneyTypeRadio;
exports.default = _default;